import React, { useEffect, useContext, useState } from 'react';
import { PropSheet, PropSheetTitle, TextField, SelectField, TextAreaField, OptionSelect, CheckboxField } from './UI';
import EditorContext, { groupChoices, statusSelectOptions } from '@mirinae/lessons/editor/modules/contexts/editor';
import { UserContext } from '@mirinae/react-auth';
import { Parts } from '@mirinae/lessons/editor/components/PropertySheets/elements/Parts';

const LessonPropSheet = ({ node }) => {
    const editor = useContext(EditorContext);
    const [userContext] = useContext(UserContext);

    if (!node.example) {
        node.example = { parts: {
            koreanParts: [{ value : "- example Korean -", color : "example" }],
            englishParts: [{ value : "- English translation -", color : "english" }]
        } };
    }
    if (!node.icon) {
        node.icon = { parts: { graphic: [ { url: '', mimeType: 'image/*' } ] } };
    }

    const onBlur = (e, field, value) => {
        editor.updateNodeField(node, field, value || e.target.value);
        // if (field === 'title' && node.startPageTitle === undefined) {
        //     spt.value = e.target.value;
        //     editor.updateNodeField(node, 'startPageTitle', e.target.value);
        // }
        editor.commitNodeUpdate(node);
    };

    return (
        <PropSheet>
            <PropSheetTitle>Lesson ({node.nodeID} / {node.lessonObjectID})</PropSheetTitle>
            <OptionSelect node={node} field={{label: 'Lesson status', value: node.status || 'Editing', choices: statusSelectOptions(userContext.user, node) }} onSelect={e => onBlur(e, 'status')} />
            <OptionSelect node={node} field={{label: 'Lesson group', value: node.group || 'Beginner', choices: groupChoices }} onSelect={e => onBlur(e, 'group')} />
            <CheckboxField label="Lesson accessible by Mirinae Free users" checked={Boolean(node.guestAccess || false)} onChange={e => onBlur(e, 'guestAccess', e.target.checked)} />
            <TextField label='Number' inputRef={input => { if (input) input.value = node.number || '--'; }} onBlur={e => onBlur(e, 'number')}  />
            <TextField label='Title' inputRef={input => { if (input) input.value = node.title; }} onBlur={e => onBlur(e, 'title')}  />
            <TextField label='Library pattern' inputRef={input => { if (input) input.value = node.libraryPattern || ''; }} onBlur={e => onBlur(e, 'libraryPattern')}  />
            <TextField label='Start page title' inputRef={input => { if (input) input.value = node.startPageTitle || ''; }} onBlur={e => onBlur(e, 'startPageTitle')}  />
            <TextField label='Subtitle' inputRef={input => { if (input) input.value = node.subtitle; }} onBlur={e => onBlur(e, 'subtitle')} />
            <TextField label='Listing label' inputRef={input => { if (input) input.value = node.listingLabel; }} onBlur={e => onBlur(e, 'listingLabel')} />
            <TextField label='Level' inputRef={input => { if (input) input.value = node.levelTitle; }}  onBlur={e => onBlur(e, 'levelTitle')} />
            <Parts label="Icon" node={node} field={node.icon} />
            <Parts label="Example" node={node} field={node.example} />
            <TextField label='Tags' inputRef={input => { if (input) input.value = node.tags; }}  onBlur={e => onBlur(e, 'tags')} />
            <TextAreaField label='Notes' inputRef={input => { if (input) input.value = node.notes; }} onBlur={e => onBlur(e, 'notes')} />
        </PropSheet>
    );
};

export default LessonPropSheet;
